<template>
  <div>
    <label>회원번호
      <input type="text" name="idNo" readonly="">
    </label>
    <br>
    <br>
    <button onclick="openContacts()">연락처 열기</button>
    <button onclick="goBack()">뒤로 가기</button>
    <br>
    <br>
    <label>이름
      <input type="text" name="name" readonly="">
    </label>
    <br>
    <label>전화번호
      <input type="text" name="number" readonly="">
    </label>
  </div>
</template>

<script>
  import {defineComponent} from 'vue';
  export default defineComponent({
    name: 'ContactTestView',
    data() {
      return {
        url: 'giftshop://open/webview?url=https%3A%2F%2Falpha-giftshop-channeling.payco.com%2F'
      }
    },
    mounted() {
      // https://developer.mozilla.org/ko/docs/Web/API/Window/DOMContentLoaded_event
      document.addEventListener('DOMContentLoaded', function () {
        let params = new URL(document.location).searchParams;
        let idNo = params.get('idNo');
        document.getElementsByName('idNo')[0].value = idNo;
      });

      if (window.ReactNativeWebView) {
        // Android
        document.addEventListener('message', listener);
        // iOS
        window.addEventListener('message', listener);
      }

      function listener(e) {
        const { name, number } = JSON.parse(e.data);
        document.getElementsByName('name')[0].value = name;
        document.getElementsByName('number')[0].value = number;
      }

      // Open contacts screen
      function openContacts() {
        window.ReactNativeWebView.postMessage('contacts');
      }

      // Pop screen
      function goBack() {
        window.ReactNativeWebView.postMessage('pop');
      }
    }
  })
  ;


</script>

